FormData.prototype.appendFile = function (this: FormData, key: string, file: File): void {
	this.append(key, file, file.name);
};

FormData.prototype.appendValueWithTypeCheck = function (this: FormData, key: string, value: unknown): void {
	switch (true) {
		case value instanceof File:
			this.appendFile(key, value);
			break;
		case typeof value === "string":
		case typeof value === "number":
		case typeof value === "boolean":
			this.append(key, value.toString());
			break;
		case value === null:
			this.append(key, "");
			break;
		default:
			throw new Error(`The array "${key}" contains an unsupported element.`);
	}
};

export {}; // this file needs to be a module
